/**
 * This function is created for adding dummy test data to your react-query responses.
 * It should only be used in development phase and should be removed before merge.
 * @param  obj  rawData                                     RAW response from your react-query
 * @param  func developmentAdjustFunc                       Function to handle merging dummy test data to response
 * @return obj  response from the developmentAdjustFunc     Returns the response from the function passed.
 */
const addDevelopmentData = ({ rawData, developmentAdjustFunc }) => {
  console.warn('Development data detected!!! Please remove before merging!!!');
  return developmentAdjustFunc(rawData);
};

export default addDevelopmentData;
